import { Controller } from "@hotwired/stimulus"

// De onderbalk klapt in tot alleen iconen zodra je naar beneden scrolt, en komt
// terug als je terug scrolt of bovenaan staat. Een scroll-luisteraar met een
// rAF-rem en geen IntersectionObserver: die levert op iOS niets af zolang een
// veeg nog uitrolt. De drempel houdt een trillende duim en het verend stuiteren
// aan de rand van de pagina erbuiten.
export default class extends Controller {
  static values = { threshold: { type: Number, default: 12 }, top: { type: Number, default: 64 } }

  connect() {
    this.lastY = window.scrollY
    this.pending = false
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  // Wie met het toetsenbord door de balk tabt moet de labels kunnen lezen.
  expand() {
    delete this.element.dataset.compact
  }

  onScroll() {
    if (this.pending) return

    this.pending = true
    requestAnimationFrame(() => {
      this.pending = false
      this.update()
    })
  }

  update() {
    // Begrensd, want iOS scrolt voorbij de onderkant en veert dan terug; dat
    // terugveren telde anders als omhoog scrollen.
    const max = document.documentElement.scrollHeight - window.innerHeight
    const y = Math.min(Math.max(window.scrollY, 0), Math.max(max, 0))
    if (y < this.topValue) {
      this.expand()
      this.lastY = y
      return
    }

    const delta = y - this.lastY
    if (Math.abs(delta) < this.thresholdValue) return

    if (delta > 0) {
      this.element.dataset.compact = ""
    } else {
      this.expand()
    }
    this.lastY = y
  }
}
